import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import {ref, watch,  reactive} from 'vue'
import { message } from 'ant-design-vue';
import type { UploadChangeParam } from 'ant-design-vue';
import OSS from 'ali-oss'
import { ossToken } from '@/api/user';
interface FileItem {
    uid: string;
    name?: string;
    status?: string;
    response?: string;
    url?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile2',
  props: {
    path: {
        type: String,
        default: ""
    },
    bnTitle: {
        type: String,
        default: "上传"
    },
    fileName: {
        type: String,
        default: ""
    },
    accept: {
        type: String,
        default: ".zip"
    },
    previewFile: {
        type: Function,
    },
    fileList: {
        type: Array,
        default: ()=>{
            return [];
        }
    },
},
  emits: ['onSuccess','beforeUpload'],
  setup(__props, { emit: emits }) {

const props = __props;



const data = reactive({
    disabled: false
})
let fileList = ref<FileItem[]>(props.fileList?.length>0 ? props.fileList : []);
watch(
    () => props.fileList, async () => {
        fileList.value = props.fileList;
    },
    {
        immediate: true,
        deep: true,
    }
);
const beforeUpload = async (file: FileItem) => {
    // file.name = props.fileName;
    // fileList.value.push(file)
    // console.log(fileList.value);
    emits('beforeUpload');
    data.disabled = true
    ossToken().then(async (res: any) => {
        let sts = res
        console.log(sts);
        const client = new OSS({
            region: sts.region,
            accessKeyId: sts.accessKey,
            accessKeySecret: sts.accessSecret,
            stsToken: sts.token,
            bucket: sts.bucket,
            secure: true,
            endpoint: sts.endpoint,
        })
        const name = props.fileName ? props.fileName : file.name
        console.log(name)
        const ali = await client.multipartUpload(props.path, file, { headers: { "Access-Control-Allow-Origin": "*" }, });
        if (ali.res.status === 200) {
            message.info(`${name}上传成功`)
            data.disabled = false
            emits('onSuccess', ali.res.requestUrls[0].split('?')[0]);
        } else {
            data.disabled = false
            message.error(`${name}上传失败`)
        }
    })
    return false;
}
const handleChange = (info: UploadChangeParam) => {
    console.log(info);
    let resFileList = [info.fileList[0]];
    if(props.fileName){
        // 重命名显示的文件名
        resFileList.map(file => {
            file.name = props.fileName;
        });
    }
    fileList.value = resFileList;
};

return (_ctx: any,_cache: any) => {
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      "before-upload": beforeUpload,
      "file-list": _unref(fileList),
      onChange: handleChange,
      accept: props.accept,
      disabled: data.disabled,
      showUploadList: { showRemoveIcon: false },
      "preview-file": __props.previewFile
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, null, {
          default: _withCtx(() => [
            (!data.disabled)
              ? (_openBlock(), _createBlock(_component_upload_outlined, { key: 0 }))
              : _createCommentVNode("", true),
            (data.disabled)
              ? (_openBlock(), _createBlock(_component_LoadingOutlined, { key: 1 }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(props.bnTitle), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["file-list", "accept", "disabled", "preview-file"])
  ]))
}
}

})